
export const Products = {
   category1: {
      name: "Microwave drawers",
      id: "mw001",
      items: [
         {
            display: "SMD2499FS",
            name: "SMD2499FS",
            id: 'SMD2499FS',
            img: './img/final/SMD2449FS.png',
            text: '24 in. Built-In Smart Convection Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveDrawerOvens/specsheets/SMD2499FS_SS_EN.pdf',
            productShow: 'SMD2449FS_On',
         },
         {
            display: "SMD2489ES",
            name: "SMD2489ES",
            id: 'SMD2489ES',
            img: './img/1.png',
            text: '24 in. 1.2 cu. ft. Sharp Stainless Steel Smart Easy Wave Open Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD2489ES_SS_EN.pdf',
            productShow: 'SMD2489ES_on',
         },
         {
            display: "SMD2470ASY",
            name: "SMD2470ASY",
            id: 'SMD2470ASY',
            img: './img/final/5.png',
            text: '24 in. 1.2 cu. ft. Sharp Stainless Steel Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD2470AS_SS_EN.pdf',
            productShow: 'SMD2470ASY_on',
         },
         {
            display: "SMD2470AH",
            name: "SMD2470AH",
            id: 'SMD2470AH',
            img: './img/final/4.png',
            text: '24 in. 1.2 cu. ft. Sharp Black Stainless Steel Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD2470AH_SS_v1.pdf',
            productShow: 'SMD2470AH_on',
         },
         {
            display: "KB6524PSY",
            name: "KB6524PSY",
            id: 'KB6524PSY',
            img: './img/final/SMO1652DS.png',
            text: '24 in. 1.2 cu. ft. Sharp Easy Open Stainless Steel Microwave Drawer\u2122',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/KB-6524PS_v2_SS.pdf',
            productShow: 'KB6524PSY_on',
         },
         {
            display: "SMD3070ASY",
            name: "SMD3070ASY",
            id: 'SMD3070ASS_Drawer_Oven',
            img: './img/final/3.png',
            text: '30 in. 1.2 cu. ft. Sharp Stainless Steel Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD3070AS_SS_EN.pdf',
            productShow: 'SMD3070ASS_Drawer_Oven_on',
         },
         {
            display: "SMD2479JS",
            name: "SMD2479JS",
            id: 'SMD2479JS',
            img: './img/SMD2479JS.png',
            text: '24 in. 1.2 cu. ft. Sharp Stainless Steel Smart Easy Wave Open Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD2479JS_SS.pdf',
            productShow: 'SMD2479JS_on',
         },
         {
            display: "SMD2440JS",
            name: "SMD2440JS",
            id: 'SMD2440JS',
            img: './img/SMD2440JS.png',
            text: '24 in. 1.2 cu. ft. Built-In Stainless Steel Microwave Drawer\u2122 Oven',
            category: 'category1',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMD2440JS_SS_EN_.pdf',
            productShow: 'SMD2440JS_on',
         }
         
      ]
   },
   category2: {
      name: "Wall Ovens",
      id: "mw002",
      items: [
         {
            display: "SWB3062GS",
            name: "SWB3052GS",
            id: 'SWB3052GS',
            img: './img/final/oven1.png',
            text: '30 in. 5.0 cu. ft. European Convection Built-In Double Wall Oven – Soft Close Door',
            category: 'category2',
            path:'',
            productShow: 'SWB3052DS_on',
         },
         {
            display: "SWA3062GS",
            name: "SWA3052GS",
            id: 'SWA3052GS',
            img: './img/final/oven2.png',
            text: '30 in. 5.0 cu. ft. European Convection Built-In Single Wall Oven – Soft Close Door',
            category: 'category2',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/WallOven/specsheet/SWA3062GS_SS_EN.pdf',
            productShow: 'SWA3052DS_on',
         },
         {
            display: "SWB3052DS",
            name: "SWB3052DS",
            id: 'SWB3052DS',
            img: './img/final/oven1.png',
            text: '30 in. 5.0 cu. ft. Stainless Steel European Convection Built-In Double Wall Oven',
            category: 'category2',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/WallOven/specsheet/SWB3052DS_SS_EN.pdf',
            productShow: 'SWB3052DS_on',
         },
         {
            display: "SWA3052DS",
            name: "SWA3052DS",
            id: 'SWA3052DS',
            img: './img/final/oven2.png',
            text: '30 in. 5.0 cu. ft. Stainless Steel European Convection Built-In Single Wall Oven',
            category: 'category2',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/WallOven/specsheet/SWA3052DS_SS_EN.pdf',
            productShow: 'SWA3052DS_on',
         },
         {
            display: "SSC2489GS",
            name: "SSC2489GS",
            id: 'SSC2489GS',
            img: './img/final/SSC2498GS.png',
            text: 'Smart Combi Built-In Steam Oven',
            category: 'category2',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/SuperSteamOvens/SpecSheets/SSC2489GS_SS_EN.pdf',
            productShow: 'SSC2489GS_ovan_on',
         },
         {
            display: "SMD3070AS",
            name: "SMD3070AS",
            id: 'SMD3070AS',
            img: './img/final/3.png',
            text: '30 in. 1.2 cu. ft. Sharp Stainless Steel Microwave Drawer\u2122 Oven',
            category: 'category1',
            path:'',
            productShow: 'SMD3070AS_on',
         }
      ]
   },
   category3: {
      name: "Refrigerators",
      id: "mw003",
      items: [
         {
            display: "SJG2254FS",
            name: "SJG2254FS",
            id: 'SJG2254FS',
            img: './img/final/frig1.png',
            text: '21.6 cu. ft. French 4-Door Counter-Depth Refrigerator with Water Dispenser',
            category: 'category3',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Refigerators/Spec%20Sheets/SJG2254FS_SS_EN_v5.pdf',
            productShow: 'SJG2254FS_on',
         },
         {
            display: "SJG2351FS",
            name: "SJG2351FS",
            id: 'SJG2351FS',
            img: './img/final/frig2.png',
            text: '22.5 cu. ft. French 4-Door Counter-Depth Refrigerator',
            category: 'category3',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Refigerators/Spec%20Sheets/SJG2351FS_SS_EN.pdf',
            productShow: 'SJG2351FS_on',
         },
         {
            display: "SJF2955KS",
            name: "SJF2955KS",
            id: 'SJF2955KS',
            img: './img/final/SJF2955KS.png',
            text: '28.9 cu. ft. French 3-Door Refrigerator with Water Dispenser',
            category: 'category3',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Refigerators/Spec%20Sheets/SJF2955KS_SS_EN.pdf',
            productShow: 'SJF2955KS_Refrigerator_ON',
         }
      ]
   },
   category4: {
      name: "Dishwashers",
      id: "mw004",
      items: [
         {
            display: "SDW6757ES",
            name: "SDW6757ES",
            id: 'SDW6757ES',
            img: './img/final/dish2.png',
            text: '24 in. Slide-In Stainless Steel 45 dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6757ES_SS_EN.pdf',
            productShow: 'SDW6757ES_on',
         },
         {
            display: "SDW6747GS",
            name: "SDW6747GS",
            id: 'SDW6747GS',
            img: './img/final/dish1.png',
            text: '24 in. Slide-In Stainless Steel Pocket Handle 45 dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6747GS_SS_EN.pdf',
            productShow: 'SDW6747GS_on',
         },
         {
            display: "SDW6767HS",
            name: "SDW6767HS",
            id: 'SDW6767HS',
            img: './img/final/dish1.png',
            text: '24 in. Smart Slide-In Stainless Steel Pocket Handle 45 dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6767HS_SS_EN.pdf',
            productShow: 'SDW6767HS_on',
         },
         {
            display: "SDW6888JS",
            name: "SDW6888JS",
            id: 'SDW6888JS',
            img: './img/final/dish1.png',
            text: '24 in. Smart Slide-In Stainless Steel Pocket Handle 42 dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6888JS_SS.pdf',
            productShow: 'SDW6888JS_on',
         },
         {
            display: "SDW6506JS",
            name: "SDW6506JS",
            id: 'SDW6506JS',
            img: './img/final/01.png',
            text: '24 in. Slide-In Stainless Steel Hybrid 49 dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6506JS_SS_EN.pdf',
            productShow: 'SDW6506JS_on',
         },
         {
            display: "SDW6736MS",
            name: "SDW6736MS",
            id: 'SDW6736MS',
            img: './img/final/SDW6736MS.png',
            text: '24 in. Stainless Steel 47dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6736MS_SS_EN.pdf',
            productShow: 'SDW6736MS_ON',
         },
         {
            display: "SDW6504MS",
            name: "SDW6504MS",
            id: 'SDW6504MS',
            img: './img/final/SDW6504MS.png',
            text: '24 in. Stainless Steel Hybrid 52dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6504MS_SS_EN.pdf',
            productShow: 'SDW6504MS_on',
         },
         {
            display: "SDW6726MS",
            name: "SDW6726MS",
            id: 'SDW6726MS',
            img: './img/final/SDW6726MS.png',
            text: '24 in. Stainless Steel 47dB Dishwasher',
            category: 'category4',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/Dishwashers/SpecSheets/SDW6726MS_SS_EN.pdf',
            productShow: 'SDW6726MS_ON',
         }

      ]
   },
   category5: {
      name: "Cooktops",
      id: "mw005",
      items: [
         {
            display: "SCR3042FB",
            name: "SCR3042FB",
            id: 'SCR3042FB',
            img: './img/final/8.png',
            text: '30 in. Drop-In Radiant Cooktop with Side Accessories',
            category: 'category5',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SCR3042FB_SS_EN_FINAL.pdf',
            productShow: 'SCR3042FB_on',
         },
         {
            display: "SDH3042DB",
            name: "SDH3042DB",
            id: 'SDH3042DB',
            img: './img/final/SDH3042DB.png',
            text: '30 in. Width Cooktop, European Black Mirror Finish Made with Premium SCHOTT Glass',
            category: 'category5',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SDH3042DB_SS_EN.pdf',
            productShow: 'SDH3042DB_on',
         },
         {
            display: "SDH3652DB",
            name: "SDH3652DB",
            id: 'SDH3652DB',
            img: './img/final/7.png',
            text: '36 in. Width Cooktop, European Black Mirror Finish Made with Premium SCHOTT Glass',
            category: 'category5',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SDH3652DB_SS_EN.pdf',
            productShow: 'SDH3652DB_on',
         },
         {
            display: "SCH3043GB",
            name: "SCH3043GB",
            id: 'SCH3043GB',
            img: './img/final/SCH3043GB.png',
            text: '30 in. Induction Cooktop with Side Accessories',
            category: 'category5',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SCH3043GB_SS_EN.pdf',
            productShow: 'SCH3043GB_on',
         }
      ]
   },
   category6: {
      name: "Range hoods",
      id: "mw006",
      items: [
         {
            display: "SHC3662FS",
            name: "SHC3662FS",
            id: 'SHC3662FS',
            img: './img/final/RH2.png',
            text: '36 in. Wall Mount Chimney Range Hood',
            category: 'category6',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/RangeHoods/Spec%20Sheets/SHC3662FS_SS_EN.pdf',
            productShow: 'SHC3662FS_on',
         },
         {
            display: "SHC3062FS",
            name: "SHC3062FS",
            id: 'SHC3062FS',
            img: './img/final/RH3.png',
            text: '30 in. Wall Mount Chimney Range Hood',
            category: 'category6',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/RangeHoods/Spec%20Sheets/SHC3062FS_SS_EN.pdf',
            productShow: 'SHC3062FS_on',
         },
         {
            display: "SHC3042FS",
            name: "SHC3042FS",
            id: 'SHC3042FS',
            img: './img/final/RH3.png',
            text: '30 in. Wall Mount Chimney Range Hood',
            category: 'category6',
            path: '',
            productShow: 'SHC3042FS_on',
         }
      ]
   },
   category7: {
      name: "Over the range microwave",
      id: "mw007",
      items: [
         {
            display: "SMO1652DS",
            name: "SMO1652DS",
            id: 'SMO1652DS',
            img: './img/new_icon/SMO1652DS11.png',
            text: '1.6 cu. ft. Stainless Steel Over-the-Range Microwave Oven ',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMO1652DS_SS_EN.pdf',
            productShow: 'SMO1652DS_on',
         },
         {
            display: "SMO1854DS",
            name: "SMO1854DS",
            id: 'SMO1854DS',
            img: './img/new_icon/SMO1652DS11.png',
            text: '1.8 cu. ft. Stainless Steel Over-the-Range Microwave Oven ',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMO1854DS_SS_EN.pdf',
            productShow: 'SMO1854DS_on',
         },
         {
            display: "SMO1759JS",
            name: "SMO1759JS",
            id: 'SMO1759JS',
            img: './img/new_icon/SMO1759JS.png',
            text: '1.7 cu. ft. Smart Over-the-Range Microwave Oven',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/WallOven/specsheet/SMO1759JS_SS_10242023.pdf',
            productShow: 'SMO1759JS_on',
         },
         {
            display: "SMO1969JS",
            name: "SMO1969JS",
            id: 'SMO1969JS',
            img: './img/new_icon/SMO1969JS.png',
            text: '1.9 cu. ft. Smart Over-the-Range-Microwave Oven',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMO1969JS_SS_EN.pdf',
            productShow: 'SMO1969JS_on',
         },
         {
            display: "SMO1754JS",
            name: "SMO1754JS",
            id: 'SMO1754JS',
            img: './img/new_icon/SMO1754JS.png',
            text: '1.7 cu. ft. Over-the Range Microwave Oven',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMO1754JS_SS_EN.pdf',
            productShow: 'SMO1754JS_on',
         },
         {
            display: "SMO1752JS",
            name: "SMO1752JS",
            id: 'SMO1752JS',
            img: './img/new_icon/SMO1752JS.png',
            text: '1.7 cu. ft. Over-the Range Microwave Oven',
            category: 'category7',
            path:'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/MicrowaveOvens/SpecSheets/SMO1752JS_SS_EN.pdf',
            productShow: 'SMO1752JS_on',
         },
      ]
   },
   category8: {
      name: "Wall Ovens",
      id: "mw008",
      items: [
         {
            display: "SWB3085HS",
            name: "SWB3085HS",
            id: 'SWB3085HS',
            img: './img/final/SWB3085HS.png',
            text: 'Smart Convection Wall Oven with Microwave Drawer™ Oven',
            category: 'category8',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/WallOven/specsheet/SWB3085HS_SS_EN_Final.pdf',
            productShow: 'SWB3085HS_on',
         }

      ]
   },
   category9: {
      name: "Cooktops",
      id: "mw009",
      items: [
         {
            display: "STR3065HS",
            name: "STR3065HS",
            id: 'STR3065HS',
            img: './img/final/STR3065HS.png',
            text: 'Smart Radiant Rangetop with Microwave Drawer™ Oven',
            category: 'category9',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/STR3065HS_SS_EN.pdf',
            productShow: 'STR3065HS_ON',
         }
      ]
   },
   category10: {
      name: "Ranges",
      id: "mw010",
      items: [
         {
            display: "SSG3065JS",
            name: "SSG3065JS",
            id: 'SSG3065JS',
            img: './img/final/SSG3065JS.png',
            text: '30 in. Gas Convection Slide-In Range with Air Fry',
            category: 'category10',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSG3065JS_SS_EN.pdf',
            productShow: 'SSG3065JS_on',
         },
         {
            display: "SSG3061JS",
            name: "SSG3061JS",
            id: 'SSG3061JS',
            img: './img/final/SSG3061JS.png',
            text: '30 in. Gas Convection Slide-In Range with Air Fry',
            category: 'category10',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSG3061JS_SS_EN.pdf',
            productShow: 'SSG3061JS_on',
         },
         {
            display: "SSR3061JS",
            name: "SSR3061JS",
            id: 'SSR3061JS',
            img: './img/final/SSG3065JS.png',
            text: '30 in. Electric Convection Slide-In Range with Air Fry',
            category: 'category10',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSR3061JS_SS_EN.pdf',
            productShow: 'SSR3061JS_on',
         },
         {
            display: "SSR3065JS",
            name: "SSR3065JS",
            id: 'SSR3065JS',
            img: './img/final/SSG3065JS.png',
            text: '30 in. Electric Convection Slide-In Range with Air Fry',
            category: 'category10',
            path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSR3065JS_SS_EN.pdf',
            productShow: 'SSR3065JS_on',
         }
      ]
   },
   category11: {
      name: "Pedestal",
      id: "mw011",
      items: [
         {
            display: "SKCD24U0GS",
            name: "SKCD24U0GS",
            id: 'SKCD24U0GS',
            img: './img/final/SKCD24U0GS.png',
            text: '24 in. Under the Counter Pedestal',
            category: 'category11',
            // path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSG3065JS_SS_EN.pdf',
            productShow: 'SKCD24U0GS_on',
         },
         {
            display: "SKMD24U0ES",
            name: "SKMD24U0ES",
            id: 'SKMD24U0ES',
            img: './img/final/SKMD24U0ES.png',
            text: '24 in. Under the Counter Microwave Drawer™ Oven Pedestal',
            category: 'category11',
            // path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSG3061JS_SS_EN.pdf',
            productShow: 'SKMD24U0ES_on',
         },
         {
            display: "Remove the Pedestal",
            name: "RemovethePedestal",
            id: 'RemovethePedestal',
            img: '',
            text: '',
            category: 'category11',
            // path: 'https://files.sharpusa.com/Downloads/ForHome/HomeAppliances/InductionCookout/specsheets/SSG3061JS_SS_EN.pdf',
            productShow: 'RemovethePedestal_on',
         }
      ]
   }
}
